import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Modal,
  Row,
  Table,
} from "reactstrap";
import React, { useEffect, useRef, useState, Fragment, useContext } from "react";
import PropTypes from "prop-types";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import {
  faDollarSign,
  faFilter,
  faList,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { fetchCondominiumCurrent } from "../../helpers/api/finance";
import { isIterableArray } from "../../helpers/utils";
import FullPagination from "../common/pagination/FullPagination";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Datetime from "react-datetime";
import { Or, PreloadState } from "../UI/preloading/PreloadState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SupportLink from "../root/support/components/SupportLink";
import NumberFormat from "react-number-format";
import {
  fetchProperties,
  findCondominiumMovements,
} from "../../helpers/api/condominium";
import CardSummary from "../UI/cards/CardSummary";
import CreateAdvancePaymentAdmin from "../finance/CreateAdvancePaymentAdmin";
import MovementVoucherLink from "../common/MovementVoucherLink";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import Logo from "../navbar/Logo";
import { useReactToPrint } from "react-to-print";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { CurrencyContext } from "../../context/Context";

const CurrentFund = ({
  setRedirect,
  setRedirectUrl,
  onEditAction,
  options,
  alternativeName,
  showPagination = true,
  ...rest
}) => {
  const { id } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { condominium, address, phone } = useSelector(
    (state) => state.condominium
  );
  const reportRef = useRef();
  const { role } = useSelector((state) => state.auth.user);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const [collapseOne, collapseOneOpen] = useState(false);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
  });

  const handleDownload = async () => {
    const canvas = await html2canvas(reportRef.current, {
      windowWidth: reportRef.current.scrollWidth,
      windowHeight: reportRef.current.scrollHeight,
    });
    const imgData = canvas.toDataURL("image/png");

    // eslint-disable-next-line new-cap
    const pdf = new jsPDF("p", "mm", "a4"); // A4 size page of PDF

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    pdf.save("Movimientos - Caja.pdf");
  };

  /*   const [params, setParams] = useState({
    state: 0,
    condominiumId: id,
    start_date: null,
    end_date: null,
  }); */
  const [formDate, setformDate] = useState({
    since: null,
    to: null,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [params, setParams] = useState({
    condominiumId: role === "manager" ? selectedCondominium : null,
    start_date: null,
    end_date: null,
  });

  /*   const {
    data,
    error,
    isLoading,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchCurrentAccount, params); */

  const [param, setParam] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });

  const {
    data: propertiesData,
    error: err,
    isLoading: propertiesIsLoading,
    meta: propertiesMeta,
    handler: {
      nextPage: propertiesNextPage,
      previousPage: propertiesPreviousPage,
      perPage: propertiesPerPage,
      goToPage: propertiesGoToPage,
    },
  } = useSWRFetchPaginationProperty(fetchProperties, param);

  const {
    data,
    isLoading,
    handler: { goToPage, nextPage, perPage, previousPage },
    meta,
  } = useSWRFetchPagination(findCondominiumMovements, params);

  const filteredData = data.map((item) => {
    try {
      const parsedDescription = JSON.parse(item.description);
      return { ...item, description: parsedDescription };
    } catch (error) {
      return item;
    }
  });

  const resolveConvertedAmount = (movement) => {
    if (movement?.amount_converted !== null && movement?.amount_converted !== undefined) {
      const storedAmount = Number(movement.amount_converted);
      if (Number.isFinite(storedAmount)) {
        return storedAmount;
      }
    }

    const amount = Number(movement?.amount);
    const exchangeRate = Number(curr?.value || 0);
    return Number.isFinite(amount) && exchangeRate > 0
      ? amount * exchangeRate
      : null;
  };

  console.log(filteredData);

  const [current, setCurrent] = useState([]);
  const fetchApiCurrent = async () => {
    const response = await fetchCondominiumCurrent(selectedCondominium);
    setCurrent(response.data[0] ? response.data[0] : []);
    console.log(response.data[0]);
  };
  useEffect(() => {
    fetchApiCurrent();
  }, []);

  const getDate = (date) => {
    var d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const ButtonAdd = ({ onClick }) => {
    return (
      <ButtonIcon color="falcon-default" onClick={onClick} icon={faPlus}>
        Crear fondo de reserva
      </ButtonIcon>
    );
  };

  const handlePaymentReserveFund = () => {
    setRedirectUrl(
      `/dashboard/finance/${selectedCondominium}/payment-reserve-fund/create`
    );
    setRedirect(true);
  };

  const ButtonAddPayment = ({ onClick }) => {
    return (
      <ButtonIcon color="falcon-default" onClick={onClick} icon={faPlus}>
        Transferencia a fondo de reserva
      </ButtonIcon>
    );
  };

  const handleCreateReserveFund = () => {
    setRedirectUrl(`/dashboard/finance/${id}/reserve-funds/create`);
    setRedirect(true);
  };

  const handleCreatePaymentFund = () => {
    setRedirectUrl(`/dashboard/finance/${id}/payment-fund/create`);
    setRedirect(true);
  };

  const handleEdit = (aliquotId) => {
    setRedirectUrl(`/dashboard/finance/${id}/aliquots/edit/${aliquotId}`);
    setRedirect(true);
  };

  const handleDropdownAction = (action) => {
    if (action === "edit") {
      onEditAction(rest);
      return;
    }
    if (action === "delete") {
      return collapseOneOpen(true);
    }
    throw new Error("invalid action");
  };

  return (
    <>
      <PageHeader
        title="Caja"
        titleTag="h2"
        description="Gestiona y administra cada una de tus fondos."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <CardSummary
        content="430,594"
        title="Saldo actual"
        to="#"
        color={current.balance >= 0 ? "sucess" : "danger"}
      >
        <PreloadState loadingClass="p-0">
          <Row>
            <Col xs={12}>
              <NumberFormat
                prefix={`${baseCurrency.symbol} `}
                thousandSeparator
                decimalScale={2}
                fixedDecimalScale
                displayType="text"
                value={current.balance}
              />
            </Col>
            <Col className="d-flex justify-content-between align-items-center">
              <PreloadState>
                <Or>
                  <span className="text-success fs--1">
                    **Utiliza tu saldo para estar al día con tus pagos.
                  </span>
                </Or>

                <div className="d-flex align-items-center justify-content-end">
                  <Dropdown isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
                    <DropdownToggle
                      caret
                      className="btn btn-falcon-default d-flex align-items-center justify-content-between"
                    >
                      Saldos a favor
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem header>Opciones</DropdownItem>
                      <DropdownItem
                        onClick={() => collapseOneOpen(!collapseOne)}
                        /*    tag={Link}
                                      to={`/dashboard/finance/${selectedCondominium}/advance/add`} */
                      >
                        <FontAwesomeIcon icon={faDollarSign} className="mr-2" />
                        Registrar saldo a favor
                      </DropdownItem>
                      <DropdownItem
                        tag={Link}
                        to="/dashboard/my/finance/advance"
                      >
                        <FontAwesomeIcon icon={faList} className="mr-2" />
                        Ver mis saldos a favor
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </PreloadState>
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col xs="auto" lg="auto" md={3} sm={3} className="mt-3">
              <ButtonAddPayment onClick={handlePaymentReserveFund} />
            </Col>
          </Row>
        </PreloadState>
      </CardSummary>
      <Modal isOpen={collapseOne} data-testid="modal">
        <CreateAdvancePaymentAdmin></CreateAdvancePaymentAdmin>
      </Modal>
      <Card className="p-0 mb-3">
        <FalconCardHeader title="" className="p-0">
          <Row className="justify-content-end">
            <Col xs="auto">
              <Row className="justify-content-center mb-3">
                <Col
                  xs="auto"
                  lg="auto"
                  md={12}
                  sm={12}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Label className="mb-0 mr-2">
                    <FontAwesomeIcon icon={faFilter} />
                  </Label>
                </Col>
                <Col
                  xs="auto"
                  sm="auto"
                  lg="auto"
                  className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                >
                  <Label className="mr-2 mb-0">Desde</Label>
                  <Datetime
                    value={formDate.since}
                    isValidDate={(current, selected) => {
                      return !current.isAfter();
                    }}
                    onChange={(d) =>
                      setformDate((prev) => ({ ...prev, since: d }))
                    }
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                  />
                </Col>
                <Col
                  xs="auto"
                  sm="auto"
                  lg="auto"
                  className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                >
                  <Label className="mr-2 mb-0">Hasta</Label>
                  <Datetime
                    value={formDate.to}
                    className="mr-2"
                    isValidDate={(current, selected) => {
                      return (
                        current.isAfter(formDate.since) && !current.isAfter()
                      );
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    onChange={(d) =>
                      setformDate((prev) => ({ ...prev, to: d }))
                    }
                  />
                </Col>
                <Col
                  xs="auto"
                  className="pl-0 d-flex align-items-md-end align-items-lg-center align-items-sm-end"
                >
                  <ButtonIcon
                    className="text-nowrap d-sm-none d-lg-block"
                    disabled={!formDate.to}
                    icon={faSearch}
                    color="falcon-default"
                    onClick={() => {
                      setParams((prev) => {
                        return {
                          ...prev,
                          start_date: formDate.since.format("YYYY-MM-DD"),
                          end_date: formDate.to.format("YYYY-MM-DD"),
                        };
                      });
                    }}
                  >
                    Buscar
                  </ButtonIcon>
                  <Button
                    className="text-nowrap d-sm-block d-lg-none"
                    disabled={!formDate.to}
                    color="falcon-default"
                    onClick={() => {
                      setParams((prev) => {
                        return {
                          ...prev,
                          start_date: formDate.since.format("YYYY-MM-DD"),
                          end_date: formDate.to.format("YYYY-MM-DD"),
                        };
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col
              xs="auto"
              lg="auto"
              md={12}
              sm={12}
              className="text-center text-md-right"
            ></Col>
          </Row>
        </FalconCardHeader>
        <CardBody>
          <Row className="justify-content-between align-items-center d-flex">
            <Col md>
              <h5 className="mb-2 mb-md-0">Descargar movimientos</h5>
            </Col>
            <Col
              xs="auto"
              lg={"auto"}
              md={12}
              className="justify-self-end d-flex justify-content-end align-items-center"
            >
              <ButtonIcon
                color="falcon-default"
                size="sm"
                icon="arrow-down"
                onClick={handleDownload}
                disabled={!filteredData}
                className="mr-2 mb-2 mb-sm-0"
              >
                Descargar (.pdf)
              </ButtonIcon>
              <ButtonIcon
                onClick={() => handlePrint()}
                color="falcon-default"
                size="sm"
                icon="print"
                disabled={!filteredData}
                className="mr-2 mb-2 mb-sm-0"
              >
                Imprimir
              </ButtonIcon>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <Card
          innerRef={(e) => {
            reportRef.current = e;
          }}
          style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
        >
          <CardBody>
            <PreloadState cond={isIterableArray(data)} loading={isLoading}>
              <Fragment>
                <Row className="align-items-center text-center mb-3">
                  <Col sm={6} className="text-sm-left">
                    <div className="text-sm-left col-sm-6">
                      <Logo width={150} />
                    </div>
                  </Col>
                  <Col sm={6} className="text-sm-right mt-3 mt-sm-0">
                    <h4>Movimientos de la caja</h4>
                    <h5>Condominio {condominium}</h5>
                    <p className="fs--1 mb-0">{address}</p>
                    <p className="fs--1 mb-0">RIF {phone}</p>
                    <h6 className="fs--1 mt-2 mb-0">Saldo Actual</h6>
                    <NumberFormat
                      prefix={`${baseCurrency.symbol} `}
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      displayType="text"
                      value={current.balance}
                    />
                  </Col>
                  {formDate.to && (
                    <Col xs={12}>
                      <hr />
                    </Col>
                  )}
                </Row>
                {/*          {formDate.to && (
                <div className="d-flex justify-content-end">
                  <h6>
                    Relación de condominio: {params.start_date} al{" "}
                    {params.end_date}
                  </h6>
                </div>
              )} */}

                {data.length > 0 ? (
                  <>
                    <Fragment>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th style={{ fontSize: "0.9rem" }}>Fecha</th>
                            <th style={{ fontSize: "0.9rem" }}>Propietario o proveedor</th>
                            <th style={{ fontSize: "0.9rem" }}>Descripción</th>
                            <th style={{ fontSize: "0.9rem" }}>Tipo</th>
                            <th style={{ fontSize: "0.9rem" }}>Monto</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData.map((movement) => (
                            <tr
                              style={{ fontSize: "0.8rem" }}
                              key={movement.id}
                            >
                              <td>{getDate(movement.created_at)}</td>
                              <td>
                                {movement?.property !== null ? (
                                  <p>
                                    {movement?.property?.user?.data?.firstname}{" "}
                                    {movement?.property?.user?.data?.lastname}
                                  </p>
                                ) : movement?.provider !== null ? (
                                  <p>{movement?.provider}</p>
                                ) : (
                                  <p>N/A</p>
                                )}
                              </td>
                              <td>
                                {movement.description.message
                                  ? movement.description.message
                                  : movement.description}
                                <MovementVoucherLink voucher={movement.voucher} />
                              </td>
                              <td>
                                {movement.isDecrement === 0 ? (
                                  <Badge
                                    className="rounded-capsule badge-soft-success"
                                    /*      color={
                                movement.isDecrement === 0
                                  ? "success"
                                  : "danger"
                              } */
                                  >
                                    Ingreso
                                    <FontAwesomeIcon
                                      className="ml-2 "
                                      icon="fa-solid fa-arrow-up"
                                    />
                                  </Badge>
                                ) : (
                                  <Badge className="rounded-capsule badge-soft-warning">
                                    Egreso
                                    <FontAwesomeIcon
                                      className="ml-2"
                                      icon="fa-solid fa-arrow-down"
                                    />
                                  </Badge>
                                )}
                              </td>
                              <td>
                                {" "}
                                <Row>
                                  <Col>
                                    <NumberFormat
                                      prefix={`${baseCurrency.symbol} `}
                                      thousandSeparator
                                      decimalScale={2}
                                      fixedDecimalScale
                                      displayType="text"
                                      value={movement.amount}
                                    />
                                    {resolveConvertedAmount(movement) !== null && (
                                      <NumberFormat
                                        className="text-right"
                                        displayType="text"
                                        thousandSeparator
                                        decimalScale={2}
                                        fixedDecimalScale
                                        prefix={` | ${curr?.currency?.iso || ""} `}
                                        value={resolveConvertedAmount(movement)}
                                      />
                                    )}
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Fragment>
                  </>
                ) : (
                  <Row className="p-card">
                    <Col>
                      <Alert color="info" className="mb-0">
                        Al parecer aún no hay movimientos para mostrar.
                      </Alert>
                    </Col>
                  </Row>
                )}
              </Fragment>
            </PreloadState>
          </CardBody>
        </Card>
        {showPagination && (
          <FullPagination
            style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
            nextPage={nextPage}
            prevPage={previousPage}
            goToPage={goToPage}
            meta={meta}
            className={"shadow-none"}
            posText={"Movimientos"}
            perPage={perPage}
          />
        )}
      </Card>
    </>
  );
};

CurrentFund.propTypes = {
  showPagination: PropTypes.bool,
};

export default withRedirect(CurrentFund);
